export const hasGiftCardLineItem = lineItems =>
  lineItems?.some(item => item.code === 'line-item/gift-card');

export const isPendingPaymentTxState = state =>
  state === 'pending-payment' || state === 'state/pending-payment';

/**
 * Pick the correct privileged transition when applying a gift card / voucher at checkout.
 */
export const resolveGiftCardTransitionName = ({
  process,
  processAlias,
  baseTransitionName,
  giftCardCode,
  transactionId,
  txState,
}) => {
  if (!giftCardCode?.trim() || !process) {
    return baseTransitionName;
  }

  const isPurchase = processAlias === 'default-purchase/release-1';
  const isBooking = processAlias?.startsWith('default-booking');
  const isPendingPayment =
    txState === 'pending-payment' || txState === 'state/pending-payment';

  if (isPurchase) {
    return process.transitions.REQUEST_PAYMENT_COUPON;
  }

  // Booking: first speculate uses request-payment (initial → pending-payment).
  // Applying a voucher to that existing tx must use request-payment-coupon.
  if (isBooking && transactionId && isPendingPayment) {
    return process.transitions.REQUEST_PAYMENT_COUPON;
  }

  return baseTransitionName;
};
